export default __webpack_public_path__ + "static/media/hire.f91ce16a.svg";